import "./index.css";
import React from "react";

export default function OnboardingSiteTabs({ selectedTab, onClick }) {
  return (
    <header className="onboarding-site__header">
      <nav className="onboarding-site__nav">
        <ul className="onboarding-site__list">
          <li
            className={`onboarding-site__list-item ${
              selectedTab === "landing"
                ? "onboarding-site__list-item--selected"
                : ""
            }`}
            onClick={() => onClick("landing")}
          >
            Landing <br className="onboarding__title-line-break" />
            page
          </li>
          <li
            className={`onboarding-site__list-item ${
              selectedTab === "layers"
                ? "onboarding-site__list-item--selected"
                : ""
            }`}
            onClick={() => onClick("layers")}
          >
            <span className="onboarding-site--hidden-on-mobile">
              Additional page layers
            </span>
            <span className="onboarding__title-line-break">
              Additional <br />
              layers
            </span>
          </li>
          <li
            className={`onboarding-site__list-item ${
              selectedTab === "pages"
                ? "onboarding-site__list-item--selected"
                : ""
            }`}
            onClick={() => onClick("pages")}
          >
            <span className="onboarding-site--hidden-on-mobile">
              Additional site pages
            </span>
            <span className="onboarding__title-line-break">
              Additional <br /> pages
            </span>
          </li>
        </ul>
      </nav>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/screens/OnboardingSite/components/OnboardingSiteTabs/index.js